import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MaterialCircularProgress from '@material-ui/core/CircularProgress';

import { Colors } from 'modules/utils';

const FlexContainer = styled.div`
	display: flex;
	justify-content: ${props => (props.centered ? 'center' : 'flex-start')};
	margin: ${props => (props.small ? 0 : '30px 0 30px 0')};
`;

const propTypes = {
	centered: PropTypes.bool,
	elementId: PropTypes.string,
	small: PropTypes.bool,
	customColor: PropTypes.string,
	autoFocus: PropTypes.bool,
};

const StyledCircularProgress = styled(({ customColor, ...props }) => (
	<MaterialCircularProgress {...props} />
)).attrs({
	classes: {
		svg: 'customSVG',
	},
})`
	.customSVG {
		color: ${({ customColor }) => customColor || Colors.BLUE};
	}
`;

const CircularProgress = ({
	centered,
	elementId,
	small,
	customColor,
	autoFocus = false,
}) => {
	const containerRef = useRef(null);
	useEffect(() => {
		if (autoFocus) {
			window.scrollTo(0, 0);
		}
	}, [autoFocus]);

	return (
		<FlexContainer
			centered={centered}
			id={elementId}
			small={small}
			tabIndex="-1"
			innerRef={containerRef}
		>
			<StyledCircularProgress
				id={`${elementId}-circle`}
				customColor={customColor}
				size={small ? 15 : 40}
			/>
		</FlexContainer>
	);
};

CircularProgress.propTypes = propTypes;

export { CircularProgress };
